"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.stageAndSavePortalSetting = exports.savePortalSetting = void 0;

var _requestEntity = _interopRequireDefault(require("settings-content-modals/utils/requestEntity"));

var _RequestEpicDescriptor = _interopRequireDefault(require("settings-content-modals/utils/RequestEpicDescriptor"));

var _actions = require("./actions");

var _selectors = require("./selectors");

var _RequestStatusTypes = _interopRequireDefault(require("settings-content-modals/EmailCreationModal/constants/RequestStatusTypes"));

var _API = _interopRequireDefault(require("./API"));

var fetchPortalSettings = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.get,
  initiatingActionType: _actions.PortalSettingsActionTypes.FETCH_PORTAL_SETTINGS,
  requestStatusSelector: _selectors.getFetchPortalSettingsRequestStatus,
  requestStatusTypeFilters: [_RequestStatusTypes.default.UNINITIALIZED, _RequestStatusTypes.default.FAILED],
  requestActions: _actions.FetchPortalSettings
}));
var savePortalSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.set,
  initiatingActionType: _actions.PortalSettingsActionTypes.SAVE_PORTAL_SETTING,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.SavePortalSetting
}));
exports.savePortalSetting = savePortalSetting;
var stageAndSavePortalSetting = (0, _requestEntity.default)(new _RequestEpicDescriptor.default({
  apiFunction: _API.default.set,
  initiatingActionType: _actions.PortalSettingsActionTypes.STAGE_AND_SAVE_PORTAL_SETTING,
  requestStatusSelector: function requestStatusSelector() {
    return true;
  },
  requestStatusTypeFilters: [true],
  requestActions: _actions.StageAndSavePortalSetting
}));
exports.stageAndSavePortalSetting = stageAndSavePortalSetting;
var _default = fetchPortalSettings;
exports.default = _default;